import PropTypes from 'prop-types';
import TableCell from '@mui/material/TableCell';

/** Actions column — clicks here do not trigger row-level view navigation. */
export default function TableActionCell({ children, align = 'center', sx, ...other }) {
  return (
    <TableCell
      align={align}
      onClick={(e) => e.stopPropagation()}
      sx={[{ cursor: 'default', whiteSpace: 'nowrap' }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
      {...other}
    >
      {children}
    </TableCell>
  );
}

TableActionCell.propTypes = {
  children: PropTypes.node,
  align: PropTypes.oneOf(['left', 'center', 'right', 'justify', 'inherit']),
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
